import { Injectable } from '@angular/core';
import { extractColors, extractColorsFromSrc, extractColorsFromImageData } from 'extract-colors'
import { FinalColor } from '../../models/colors';
import { environment } from 'environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ColorsCountService {

  constructor() { }

  private options = {
    pixels: 900000,
    distance: 0.10,
    saturationDistance: 0.2,
    lightnessDistance: 0.2,
    hueDistance: 0.083,
    crossOrigin: "anonymous"
  }

  async getImageColors(imageURL: string): Promise<FinalColor[]> {
    // check the environment if it's production then do not run this code
    return new Promise((resolve, reject) => {
        const canvas = document.createElement('canvas');
        const context = canvas.getContext('2d');

        const img = new Image();
        img.crossOrigin = 'anonymous';
        img.src = imageURL;
        img.onload = async () => {
            try {
                canvas.width = img.width;
                canvas.height = img.height;

                context.drawImage(img, 0, 0);
                const imageData = context.getImageData(0, 0, img.width, img.height);
                const colors = await extractColorsFromImageData(imageData, {
                  pixels: 900000,
                  distance: 0.15,
                  saturationDistance: 0.2,
                  lightnessDistance: 0.2,
                  hueDistance: 0.083,
                  crossOrigin: "anonymous"
                })
                resolve(colors);
            } catch (error) {
                console.error("Error in img.onload:", error);
                reject(error);
            }
        };

        img.onerror = (err) => {
            console.error(`Error loading image ${imageURL}:`, err);
            reject(new Error('Image loading failed'));
        };
    });
  }



}
